var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-skeleton-loader',{attrs:{"loading":_vm.loading,"type":"list-item","transition":"scale-transition","width":"20%"}},[_c('v-text-field',{attrs:{"solo":"","flat":"","dense":"","persistent-hint":"","hint":_vm.label,"value":_vm.value,"readonly":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }